import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Dashboard from "layouts/dashboard";
import ProfStats from "prof/ProfStats";

const TAB_APPLICATION_SALES = 0;
const TAB_UNIVERSITY_STATS = 1;

export default function AdminStatsPage() {
  const [tab, setTab] = useState(TAB_APPLICATION_SALES);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
        >
          <Tab label="Application sales" id="stats-tab-0" aria-controls="stats-panel-0" />
          <Tab label="University stats" id="stats-tab-1" aria-controls="stats-panel-1" />
        </Tabs>
        <MDBox role="tabpanel" id="stats-panel-0" aria-labelledby="stats-tab-0" hidden={tab !== TAB_APPLICATION_SALES}>
          {tab === TAB_APPLICATION_SALES && <Dashboard noLayout />}
        </MDBox>
        <MDBox role="tabpanel" id="stats-panel-1" aria-labelledby="stats-tab-1" hidden={tab !== TAB_UNIVERSITY_STATS}>
          {tab === TAB_UNIVERSITY_STATS && <ProfStats noLayout />}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
